<template>
  <div class="show-teachers">
    <Header :title="title"></Header>
    <div class="course-fitler">
      <van-dropdown-menu :active-color="$theme_color">
        <van-dropdown-item title="分类" ref="attr">
          <div class="parent-box">
            <div class="tm-kind" v-for="(attrItem, index) in attrs" :key="index">
              <p>{{attrItem.attr}}</p>
              <div class="tmk-item">
                <span
                  :class="{active: attrCondition[attrItem.id] == valueItem.id}"
                  v-for="(valueItem, index) in attrItem.value"
                  :key="index"
                  @click="onClickAttr(attrItem.id, valueItem.id)"
                >{{valueItem.name}}</span>
              </div>
            </div>
            <div class="seach-btn">
              <van-button @click="onReset">重置</van-button>
              <van-button @click="onSearch">确定</van-button>
            </div>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <List
      ref="list"
      url="/api/app/teacher/search/attrs"
      method="get"
      :params="params"
      :on-getdata="onGetdata"
      :showText="teachers.length > 0"
    >
      <div class="card-list" slot="item">
        <div class="card" v-for="(item, index) in teachers" :key="index" @click="onClickCard(item)">
          <div class="avatar-box">
            <img class="avatar" :src="item.avatar" alt />
          </div>
          <div class="info">
            <p class="name-box">
              <span class="name">{{item.real_name}}</span>
              <span class="level">{{item.level}}</span>
            </p>
            <p class="introduction">
              <span>{{item.introduction}}</span>
            </p>
          </div>
        </div>
      </div>
    </List>
  </div>
</template>

<script>
import Header from "@/components/Header";
import List from "@/components/List";
export default {
  name: "show-teachers",
  components: {
    Header,
    List
  },
  data() {
    return {
      title: {
        name: "讲师"
      },
      attrs: [],
      attrCondition: {},
      teachers: [],
      params: {}
    };
  },
  created() {
    this.requestAttr();
  },
  methods: {
    // on event
    onTest() {
      console.log(this.$refs.list);
    },
    onClickAttr(attrID, valueID) {
      this.$set(this.attrCondition, attrID, valueID);
    },
    onReset() {
      this.attrCondition = {};
    },
    onSearch() {
      const ary = [];
      for (const key in this.attrCondition) {
        if (this.attrCondition[key]) {
          ary.push(this.attrCondition[key]);
        }
      }
      this.params = {
        attr_val_id: ary.join()
      };
      this.$refs.list.reset();
      this.$refs.attr.toggle();
    },
    onGetdata(data) {
      this.teachers = data;
    },
    onClickCard(item) {
      this.$router.push({
        name: 'Teacher',
        query: {
          id: item.id
        }
      })
    },
    // other
    // request
    requestAttr() {
      this.$http.get("/api/app/attribute/3").then(data => {
        this.attrs = data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.show-teachers {
  .search {
    width: 38px;
    height: 40px;
    margin-top: 20px;
  }
  /deep/.van-dropdown-menu__item {
    width: 33.3%;
    flex: none;
  }
  .parent-box {
    padding-left: 30px;
    padding-bottom: 20px;
    .tm-kind {
      padding-bottom: 20px;
      border-bottom: 1px solid #f1f1f1;
      p {
        padding: 32px 0 20px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
      }
      .tmk-item {
        span {
          margin: 0 46px 14px 0;
          display: inline-block;
          width: 138px;
          height: 66px;
          background: rgba(245, 245, 245, 1);
          border-radius: 6px;
          font-size: 26px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #646464;
          text-align: center;
          line-height: 66px;
          overflow: hidden;
          &:nth-child(4n + 0) {
            margin-right: 0;
          }
        }
        span.active {
          color: $theme_color;
          background: #ebeefe;
        }
      }
    }
    .seach-btn {
      padding: 30px 0px;
      display: flex;
      justify-content: space-between;
      button {
        width: 340px;
        height: 66px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        border: 2px solid rgba(217, 217, 217, 1);
        font-size: 26px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        margin-right: 20px;
        &:last-child {
          color: #fff;
          background: $theme_color;
          border: 0;
        }
      }
    }
  }
  .card-list {
    padding: 30px;
    .card {
      padding: 30px;
      box-sizing: border-box;
      height: 162px;
      margin-bottom: 20px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: flex-start;
      // align-content: center;
      .avatar-box {
        @extend %flex-center;
        // width: 140px;
        margin-right: 24px;
        .avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
      }
      .info {
        // padding: 30px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .name-box {
          margin-bottom: 10px;
          height: 50%;
          * {
            vertical-align: middle;
          }
          .name {
            font-size: 30px;
            color: #595959;
            margin-right: 12px;
          }
          .level {
            font-size: 22px;
            color: #4169ff;
          }
        }
        .introduction {
          height: 50%;
          width: 520px;
          font-size: 24px;
          line-height: 34px;
          color: #b7b7b7;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>